import axios from "axios";
import { getLangFromPath } from "../utils/getLangFromPath ";

export const registerUser = async (email) => {
  const lang = getLangFromPath();
  const response = await axios.post(
    "https://eliteluxora.vps.webdock.cloud/api/auth/send-otp",
    {
      email,
    },
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
  return response;
};

export const verifyOtp = async (data) => {
  try {
    const lang = getLangFromPath();
    const response = await axios.post(
      "https://eliteluxora.vps.webdock.cloud/api/auth/verify-otp",
      data,

      // email,
      // otp,
      // password,
      // passwordConfirm
      {
        headers: {
          "Accept-Language": lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    return error;
  }
};
